import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getCentrosCompostajes = async () => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/centros?empresa=${userInfo.empresa}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const crearCentrosCompostaje = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        
        const {data}  = await Axios.post(
            '/centros', clienteData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updateCentrosCompostaje = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        const {data}  = await Axios.patch(
          `/centros/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const deleteCentrosCompostaje = (Id) => Axios.delete(`/centros/${Id}`);